<template lang="pug">
  BasePopup(@close="close(false)" v-if="isOpened" :zIndex="999999999")
    .b-confirm-popup
      ._text(v-if="text" v-html="preparedText")
      ._text(v-else)
        slot
      ._desc(v-if="desc" v-html="preparedDesc")
      BaseInput._input(v-model="value")
      ._buttons
        Btn(blue @click="close(true)") OK
        Btn(grey @click="close(false)") Отмена
</template>

<script>
import BasePopup from '@/components/BasePopup.vue';
import colorify from '@/utils/colorify';
import htmlspecialchars from '@/utils/htmlspecialchars';
import BaseInput from '@/components/BaseInput.vue';

export default {
  name: 'PopupConfirm',
  components: { BaseInput, BasePopup },
  controller: null,
  data() {
    return {
      isOpened: false,
      text: '',
      desc: '',
      value: '',
    };
  },
  computed: {
    preparedText() { return colorify(htmlspecialchars.encode(this.text)); },
    preparedDesc() { return colorify(htmlspecialchars.encode(this.desc)); },
  },
  methods: {
    open(text, desc = '', defValue = '') {
      this.isOpened = true;
      this.text = text;
      this.desc = desc;
      this.value = defValue;
      document.body.style.overflow = 'hidden';

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close(result) {
      this.isOpened = false;
      const answer = result ? this.value : null;
      this.$options.controller.resolve(answer);
      document.body.style.overflow = 'visible';
    },
  },
};
</script>

<style scoped lang="scss">
  .confirm-popup {
    max-width: 536px;

    &__text {
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0.02em;
      margin-bottom: 40px;
    }

    &__desc {
      letter-spacing: 0.02em;
      margin-bottom: 40px;
      text-align: center;
    }

    &__input {
      margin-bottom: 30px;
    }

    &__buttons {
      display: flex;
      justify-content: center;
      gap: 30px;
    }
  }
</style>
